/**
 * featureFlags.ts
 *
 * Pure rules for beta features. Grants come from the login response through
 * `stores/featureFlagStore.ts`; administrators always see a gated feature so
 * they can keep testing it in production.
 */

/** The Dư chuẩn feature's name in user_features and the login response. */
export const FEATURE_BET_LIMIT = "bet_limit";

/** Routes that belong to the Dư chuẩn feature. */
export const BET_LIMIT_PATHS: readonly string[] = ["/limit", "/customers/limits"];

/**
 * Tells whether a route path belongs to the Dư chuẩn feature. A trailing slash
 * is ignored, so "/limit/" matches like "/limit".
 *
 * @param path - The route path, without query or hash.
 * @returns True for the feature's routes.
 */
export function isBetLimitPath(path: string): boolean {
  return BET_LIMIT_PATHS.includes(path.length > 1 ? path.replace(/\/+$/, "") : path);
}

/**
 * Tells whether the current user may see the Dư chuẩn feature.
 *
 * @param isAdmin - True for administrators, who always see it.
 * @param enabled - True when an admin granted this user the feature.
 * @returns True when the feature's menu entry, routes and buttons are shown.
 */
export function canSeeBetLimit(isAdmin: boolean, enabled: boolean): boolean {
  return isAdmin || enabled;
}
